// @ts-nocheck
import _ from 'lodash';
import moment from 'moment';
import ActionTypes from '../constants/actions';

const defaultState = { showSnackbar: false, snackbarMesssage: '', dialogOpen: false, dialogMessage: '', code: 200 };

export default (state = defaultState, action) => {
  const { title, msg } = action.payload || {};
  switch (action.type) {
    case ActionTypes.SHOW_SUCCESS:
      return { ...state, showSnackbar: true, snackbarMesssage: `${title}: ${msg}`, color: 'green' };
    case ActionTypes.SHOW_ERROR:
      debugger;
      return { ...state, showSnackbar: true, snackbarMesssage: `${title}: ${msg}`, color: 'red' };
    default:
      return state;
  }
};